import { TRUST_STATS } from "../lib/data";

export const TrustBar = () => {
  return (
    <section
      data-testid="trust-bar"
      className="bg-white border-y border-gray-200"
    >
      <div className="msc-container py-8 sm:py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
          {TRUST_STATS.map((s) => (
            <div
              key={s.label}
              data-testid={`trust-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-center md:text-left"
            >
              <div className="font-display font-black text-3xl sm:text-4xl text-[#1E3A8A] leading-none">
                {s.number}
              </div>
              <div className="mt-2 font-semibold text-sm text-[#1F2937]">
                {s.label}
              </div>
              <div className="text-xs text-[#4B5563] mt-0.5">{s.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
